<template>
<CCard>
<CCardHeader>
<h3>Store</h3>
</CCardHeader>
<CCardBody>
          <div class="card-body row">
             <div class="col-lg-3">
                <div class="card border-0 mb-3 round-12 font-size-14" >

                <div class="card-header  bg-gray border-success p-0 border-0 cus-header">
                     <img  v-if="user.cImage" :src="user.cImage" style="width:100%" class="bg-gray">
                     <img   v-else   src="../assets/No-image.png" style="width:100%" class="bg-gray">

</div>

                <div class="card-body bg-gray round-bt-12 round-12 pt-2 p-3">
                   <h3 class="card-title font-size-21 text-left mb-2">{{user.cName}}</h3>
                   <div class="card-text content-details">


                      <div class="d-flex mt-2">
                         <div class="pr-4 light-gray m-width-70 text-right">
                            Address
                         </div>
                         <div class="cus-address">
                            <span class="" v-if="user.cAddress">
{{user.cAddress
}}                            </span>
                            <span class="" v-else>
                            --
                            </span>

                         </div>
                      </div>
                                            <div class="d-flex mt-2">
                         <div class="pr-4 light-gray m-width-70 text-right">
                            Description
                         </div>
                         <div class="cus-address">
                            <span class="" v-if="user.cDescription">
{{user.cDescription
}}                            </span>
                            <span class="" v-else>
                            --
                            </span>

                         </div>
                      </div>

                                       <CCardFooter>
                             <button type="button" @click="editbusiness(user)" class="btn btn-success btn-lg btn-block mr-3 text-uppercase" >Edit </button>

          </CCardFooter>

                   </div>
                </div>

                 </div>
          </div>

    </div>

</CCardBody>
</CCard>

</template>
<script>
import firebase from "firebase";
import { uuid } from "vue-uuid";
// import CreditCardForm from "/profile/CreditCardForm";
import vSelect from "vue-select";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Multiselect from "vue-multiselect";
import vCurrencySelect from "vue-currency-select";
import Vue from "vue";
import VueTagsInput from '@johmun/vue-tags-input';

Vue.use(vCurrencySelect);

import "vue-select/dist/vue-select.css";
// import VueFormWizard from 'vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// Vue.use(VueFormWizard)
// import {FormWizard, TabContent} from 'vue-form-wizard'
// import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { validationMixin } from "vuelidate"
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"

export default {
  components: {
    Multiselect,
    vSelect,
    VueTagsInput,
    FormWizard,TabContent,
  },
  data() {
    return {
            submitted: false,

              address: {},
      user: {
        deliveryOption: '',
        deliveryOptions: [],
      },
      businessOption: [],
      imageData: null,
      img1: "",
      imageFileDisp: null,
      updated : false,
      deleted : false,
      categoryDeleted : false,
    };
  },
    computed: {
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(3)
      },
      lastName: {
        required,
        minLength: minLength(2)
      },
      email: {
        required,
        email
      },
      phone:{
        required
      }
    }
  },



  methods: {
        checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || field.$model === '')
    },
        submit () {
          this.update();
    },

    validate () {
      this.$v.$touch()
    },
editbusiness(user){
      this.$router.push({
        name: "Edit Business",
        params: {
          id: user.id,
          data: user,
        },
      });

},
    onComplete(){
    },
getAddressData: function (addressData, placeResultData, id) {
                this.address = addressData;
            },

    selectChanged(e) {
      var currency_symbols = {
        USD: "$", // US Dollar
        EUR: "€", // Euro
        CRC: "₡", // Costa Rican Colón
        GBP: "£", // British Pound Sterling
        ILS: "₪", // Israeli New Sheqel
        INR: "₹", // Indian Rupee
        JPY: "¥", // Japanese Yen
        KRW: "₩", // South Korean Won
        NGN: "₦", // Nigerian Naira
        PHP: "₱", // Philippine Peso
        PLN: "zł", // Polish Zloty
        PYG: "₲", // Paraguayan Guarani
        THB: "฿", // Thai Baht
        UAH: "₴", // Ukrainian Hryvnia
        VND: "₫", // Vietnamese Dong
      };
      let currency_name = this.user.currency;
      if (currency_symbols[currency_name] !== undefined) {
        this.user.symbol = currency_symbols[currency_name];
      }
      else {
        this.user.symbol = currency_name;
      }
    },
    logout() {
      localStorage.clear();
    },
    previewImage: function (event) {
      this.uploadValue = 0;
      this.img1 = null;
      this.imageData = event.target.files[0];
      this.uuidvalue = uuid.v1();
      this.onUpload();
    },
    onImageSelected(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createFileImage(files[0]);
      this.previewImage(e);
    },
    createFileImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.imageFileDisp = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onUpload() {
      this.img1 = null;
      const storageRef = firebase
        .storage()
        .ref(this.uuidvalue)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.img1 = url;
            this.user.photoUrl = url;
            return this.img1;
          });
        }
      );
    },
    getbusinessList() {
      const db = firebase.firestore();
      this.businessOption = [];
      db.collection("businessType")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.businessOption=(doc.data().businessType);
                        this.datavalue = {
                          businessType: doc.data().businessType,

                        }

          });
        });
    },

    getUserDetails() {
      const db = firebase.firestore();
      let temp;
      db.collection("users")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.id = doc.id;
            temp = {
              'nickname' : doc.data().nickname,
              'aboutMe' : doc.data().aboutMe,
              'phone' : doc.data().phone,
              'email' : doc.data().email,
              'photoUrl' : doc.data().photoUrl,
              'currency' : doc.data().currency,
              'cName' : doc.data().cName,
              'cEmail':doc.data().cEmail,
              'type' : doc.data().type,
              'websiteurl' : doc.data().websiteurl,
              'latLong' : doc.data().latLong,
              'twitter' : doc.data().twitter,
              'linkedin' : doc.data().linkedin,
              'instagram':doc.data().instagram,
              'google':doc.data().google,
              'location' : doc.data().location,
              'facebook' : doc.data().facebook,
              'paymentmethod' : doc.data().paymentmethod,
              'cDescription' : doc.data().cDescription,
              'openTime' : doc.data().openTime,
              'cType' : doc.data().cType,
              'symbol' : doc.data().symbol,
              'deliveryOption' : doc.data().deliveryOption,
              'firstName':doc.data().firstName,
              'lastName':doc.data().lastName,
               'symbol' : doc.data().symbol,
               'cImage':doc.data().cImage,
               'cEmail':doc.data().cEmail,
               'cbsts':doc.data().cbsts,
               'cbName':doc.data().cbName,
               'cbaccno':doc.data().cbaccno,
               'cbbranch':doc.data().cbbranch,
               'cbifsc':doc.data().cbifsc,
                'cConName':doc.data().cConName,
                'cConEmail':doc.data().cConEmail,
                'ecomsts':doc.data().ecomsts,
                'apptsts':doc.data().apptsts,

            }
            this.user = temp;
          });
        });
    },
    deleteProduct(){
        const db = firebase.firestore();
        db.collection('products').where('Id', '==' ,firebase.auth().currentUser.uid).get()
          .then(
            function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
              // doc.data() is never undefined for query doc snapshots
                doc.ref.delete();
              }
              );
            },
    this.deleteCategory()
    )
      },
      deleteCategory(){
        const db = firebase.firestore();
        db.collection('category').where('Id', '==' ,firebase.auth().currentUser.uid).get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              doc.ref.delete();
            })
          })
      },
    update() {
      const db = firebase.firestore();
      for (let [key, value] of Object.entries(this.user)) {
        if(key && !value){
          this.user[key] = null;
        }
      }
      this.user.deliveryOption = []
      for (var key in this.user.deliveryOptions) {
        if (this.user.deliveryOptions.hasOwnProperty(key)) {
          let a = this.user.deliveryOptions[key]
          let text = a['text']
          this.user.deliveryOption.push(text)
        }
      }
      db.collection("users")
        .doc(this.id)
        .update({
          nickname: this.user.firstName +' '+ this.user.lastName,
          firstName:this.user.firstName,
          lastName:this.user.lastName,
          aboutMe: this.user.aboutMe,
          phone: this.user.phone,
          email: this.user.email,
          photoUrl: this.user.photoUrl,
          currency: this.user.currency,
          cName: this.user.cName,
          symbol : this.user.symbol,
          type: this.user.type,
          google: this.user.google,
          instagram:this.user.instagram,
          latLong: this.user.latLong,
          twitter: this.user.twitter,
          linkedin: this.user.linkedin,
          facebook: this.user.facebook,
          paymentmethod: this.user.paymentmethod,
          cAddress : this.address,
          cDescription : this.user.cDescription,
          openTime : this.user.openTime,
          cType : this.user.cType,
          deliveryOption : this.user.deliveryOption,
        })
        .then(()=>{
          this.updated = true;
          localStorage.setItem("symbol",this.user.symbol)
        })
        .catch((error) => {
          console.log(error, "error");
        });
    },
  },
  created: function () {
    this.getUserDetails();
    this.getbusinessList();
  },
};
</script>
<style scoped>
.error {
  color: red;
}
.btncen {
  text-align: center;
}

.ifdre {
  height: 35% !important;
  padding-left: 2%;
  width: 10%;
  float: right;
  padding-bottom: 3%;
}

.custom-file {
  position: relative;
  margin-left: 1%;
  /* padding-left: 91px; */
  display: inline-block;
  width: 40%;
  height: calc(2.0625rem + 2px);
  margin-bottom: 5%;
}
.profile {
  color: gray;
  background-color: whitesmoke;
}
.profile1 {
  color: black;
  background-color: white;
  height: 300;
  width: 400 !important;
}
.hello {
  margin: 20px;
}
textarea.form-control {
  height: 211%;
}
h4{
  color:tomato;
  text-align:right;
  padding:10px;
}
</style>
